<template>
  <div class="profile-settings-container">
    <div class="ui-block">
      <div v-if="(userProfile.id === loggedUser.id)">
        <FormPersonalInfo :user="userProfile"/>
        <FormEmail />
        <FormPassword />
        <FormDeactivateAccount />
      </div>
      <div v-else class="ui-block">
        <div class="ui-block-title">
          <h6 class="title text-danger">You cannot change another user's settings</h6>
        </div>
      </div> 
    </div>
  </div> 
</template>

<script>
import UserHelperVue from "../../mixins/UserHelper.vue";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import FormEmail from "@/components/molecules/FormEmail";
import FormPassword from "@/components/molecules/FormPassword";
import FormDeactivateAccount from './FormDeactivateAccount.vue';
import FormPersonalInfo from './FormPersonalInfo.vue';

export default {
  name: "ProfileSettings",
  props: ["userProfile", "hasUserNameError"],
  components: { FormEmail, FormPassword, FormDeactivateAccount, FormPersonalInfo },
  mixins: [UserHelperVue, ChatHelperVue],
};
</script>
<style scoped>
.profile-settings-container {
  padding-left: 8px;
  width: 100%;
}
@media screen and (max-width:1023px) {
  .profile-settings-container {
    padding: 0 8px;
  }
}
</style>